// Pages reachable via a token link without a user session (customer link, warehouse TV).
const PUBLIC_PATH_PREFIXES = ["/lieferdatum/", "/display/"];

export function isPublicPath(pathname) {
  return PUBLIC_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
